import type { PropDefaults, PropElement, PropTypes } from "@platform/react-storybook/Component";
import type { UuidText } from "../../Text/types";

import type { PropCard } from "../types";
import Namespace from "./_index.scss";

export const { NAME_CHALLENGES_CARD, TYPE_CHALLENGES_CARD } = Namespace;

type PropParent = Required<Pick<PropCard, "href" | "bitmap">>;

type PropWithUuid = {
    /** Caption of the card */
    summary: UuidText;
    "summary-text"?: never;
};

type PropWithText = {
    summary?: never;
    /** Caption of the card. Text format */
    "summary-text"?: string;
};

type TitleWithUuid = {
    /** Title of the card */
    title: UuidText;
    "title-text"?: never;
};

type TitleWithText = {
    title?: never;
    /** Title of the card. Text format */
    "title-text"?: string;
};

export type PropChallengesCard = PropElement &
    PropParent &
    (PropWithUuid | PropWithText) &
    (TitleWithUuid | TitleWithText) & {
        /**	If enabled, the box won’t allow its contents to be interacted with,
         * because a special layer will be placed above it all. */
        locked?: boolean;
        /** If it has a title  */
        hasFade?: boolean;
    };

export const DEF_CHALLENGES_CARD: PropDefaults<
    Omit<
        PropChallengesCard,
        "title" | "locked" | "summary" | "summary-text" | "hasFade" | "title" | "title-text"
    >
> = {};

export type PropTypesChallengesCard = PropTypes<PropChallengesCard, typeof DEF_CHALLENGES_CARD>;
